/**
 * Created by staffanrantzow on 16/06/16.
 */

import axios from 'axios';
import WorkerEntity from './worker-entity';
import {APIResult} from '../http';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

class WorkerService {
  hydrate (worker) {
    let attr = worker.attributes;

    return new WorkerEntity(
      worker.id,
      attr.account_clearing_number,
      attr.account_number,
      attr.bic,
      attr.cellphone,
      attr.city,
      attr.co,
      attr.country,
      attr.created_at,
      attr.default_taxkey_id,
      attr.display_hsd,
      attr.email,
      attr.first_name,
      attr.iban,
      attr.international_account,
      attr.last_login,
      attr.last_name,
      attr.notification_language,
      attr.preferred_payment_type_id,
      attr.profession_title,
      attr.profession_id,
      attr.save_itp,
      attr.itp_rate,
      attr.save_vacation_pay,
      attr.social_security_number,
      attr.street,
      attr.user_id_owner,
      attr.zip
    );
  }

  hydrateCollection (data) {
    var workers = [];

    for (let worker of data) {
      workers.push(this.hydrate(worker));
    }

    return workers;
  }

  getError (error) {
    let status = (error.response || { status: 200 }).status;
    if (status === 422) {
      let errorMessages = [];
      for (let error of error.response.data.errors) {
        if (error.detail.hasOwnProperty('errors')) {
          if (error.detail.errors.hasOwnProperty('social_security_number')) {
            errorMessages.push(proxyCounterpart('PERSONAL_NUMBER_ERROR_BACKEND'));
          }
          if (error.detail.errors.hasOwnProperty('cellphone')) {
            errorMessages.push(proxyCounterpart('VALIDATION_CELLPHONE_PHONENUMBER'));
          }
        }
      }

      if (errorMessages.length > 0) {
        return errorMessages;
      }
    }

    return false;
  }

  extractParams (params) {
    return {
      data: {
        attributes: {
          first_name: params.firstName,
          last_name: params.lastName,
          cellphone: params.cellphone,
          street: params.street,
          city: params.city,
          zip: params.zip,
          social_security_number: params.socialSecurityNumber,
          profession_title: params.professionTitle,
          profession_id: params.professionId,
          account_clearing_number: params.accountClearingNumber,
          account_number: params.accountNumber,
          email: params.email,
          country: params.country,
          international_account: params.internationalAccount,
          bic: params.bic,
          iban: params.iban
        }
      }
    };
  }

  post (params) {
    let data = this.extractParams(params);

    return axios.request({
      url: 'backend://workers',
      method: 'POST',
      data: data
    });
  }

  get () {
    return axios.get('backend://workers', { params: {
      'page[number]': 1,
      'page[size]': 25,
      'sort': 'first_name'
    }})
      .then((response) => {
        let workers = this.hydrateCollection(response.data.data);
        return new APIResult(workers, response.data.meta);
      });
  }

  getWorker (id) {
    return axios.get(`backend://workers/${id}`)
      .then((response) => {
        let worker = this.hydrateCollection([response.data.data]);
        return worker;
      });
  }

  searchByLastName (name) {
    return axios.get('backend://workers', { params: {
      'page[size]': 100,
      'sort': 'first_name',
      'filter[last_name][^]': name
    }})
      .then((response) => {
        let workers = this.hydrateCollection(response.data.data);
        return new APIResult(workers, response.data.meta);
      });
  }
}

export default new WorkerService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/workers/worker-service.js
 **/